<template>
  <HgBreadcrumb
    v-if="links.length > 0"
    data-testid="breadCrumbs"
    :theme="isIs24 ? 'is24' : 'hg'"
    :links="links"
    :class="['layout-container', $style.breadcrumbs]"
  />
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { getLocationInfos } from '@/helpers/GeoLocation/GeoLocationHelper';
import { isPlatformIs24 } from '@/helpers/Platform/Platform';
import { BASE_PATH } from '@/router/routes/constants';
import { useLocalLandingStore } from '@/stores/localLanding/localLanding';
import { HgBreadcrumb, HgSupportedLanguage } from '@smg-real-estate/domus';

const localLandingStore = useLocalLandingStore();
const { t, locale } = useI18n();
const { routeGeoLocation } = storeToRefs(localLandingStore);

const isIs24 = isPlatformIs24();

const routeLocationName = computed((): string => {
  return getLocationInfos(routeGeoLocation.value, locale.value as HgSupportedLanguage).name;
});

const links = computed(() => {
  const baseUrl = import.meta.env.VUE_APP_BASE_URL;
  return [
    {
      name: isIs24 ? '' : t(`localLanding.breadcrumb.home`),
      link: `${baseUrl}/${locale.value}`,
    },
    {
      name: t(`localLanding.breadcrumb.locationPage`, [routeLocationName.value]),
      link: `${baseUrl}${BASE_PATH[locale.value as HgSupportedLanguage]}`,
    },
    {
      name: isIs24 ? t(`localLanding.breadcrumb.finalPage`) : routeLocationName.value,
      link: '',
    },
  ];
});
</script>
<style lang="scss" module>
@use '@/assets/variables' as *;

.breadcrumbs {
  margin-bottom: 0;

  li:nth-child(3) {
    > a {
      color: $color-grey-80;
      pointer-events: none;
      cursor: default;
    }
  }
}
</style>
